import { observer } from 'mobx-react';
import InvitationsCreated from './InvitationsCreated';
import InvitationsScheduled from './InvitationsScheduled';
import { when } from '@execonline-inc/maybe-adapter';
import { equals } from '@execonline-inc/collections';

export interface Props {
  sendEmailDate: Date;
  skipCommunications: boolean;
  successfulCommunicationsCount: number;
  children: React.ReactNode;
}

function Body({
  successfulCommunicationsCount,
  children,
  sendEmailDate,
  skipCommunications,
}: Props) {
  return (
    <>
      {when(equals(true), skipCommunications)
        .map(() => <InvitationsCreated />)
        .getOrElse(() => (
          <InvitationsScheduled
            successfulCommunicationsCount={successfulCommunicationsCount}
            date={sendEmailDate}
          />
        ))}

      {children}
    </>
  );
}

export default observer(Body);
